module.exports = __webpack_public_path__ + "img/1440.d957d41f.jpg";